import React from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Calendar } from '@hhgtech/icons/other'
import { Box } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { BlockItemPropsType } from '..'

const ImageIcon = ({
  icon = <Calendar />,
  title,
  className,
  classNames,
  styles,
  iconSize = 32,
  ...boxProps
}: BlockItemPropsType) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'CarePathHeroBannerNavigatorImageIcon',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()

  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <Box className={classes.imgWrapper}>
        {React.cloneElement(icon, {
          size: isMobile ? 24 : iconSize,
          color: '#ffffff',
        })}
      </Box>
      {title && (
        <Text className={classes.title} size="s3" weight="semiBold">
          {title}
        </Text>
      )}
    </Box>
  )
}

ImageIcon.displayName = 'ImageIcon'

export { ImageIcon }
